import { nakiRadioSystemTypes } from "common/constants";
import BaseHomeSectionListViewStore from "./BaseHomeSectionListViewStore";

class NakiMobileHandheldPinkHomeSectionListViewStore extends BaseHomeSectionListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, { routeStore });
        this.mobileAppSystemType = nakiRadioSystemTypes.mobile_handheld_pink;
    }
}

export default NakiMobileHandheldPinkHomeSectionListViewStore;
